module.exports = __webpack_public_path__ + "static/media/arrow.090e34bf.svg";